import MessageAvatar from "components/MessageBubble/MessageAvatar";
import classNames from "shared/utils/classNames";

import { ISendButtonProps, SendButton } from "./SendButton";
import { TextOnlyMessage } from "./TextOnlyMessage";

export interface IBaseBubbleProps extends ISendButtonProps {
  label?: string;
  noSendButton?: boolean;
  isSkipable?: boolean;
  errorMessage?: string | null;
  isIframe?: boolean;
  botAvatar: string;
  isLastMessage?: boolean;
  isTextArea?: boolean;
  isTextOnly?: boolean;
}

export function BaseBubble(props: IBaseBubbleProps) {
  const {
    label,
    type,
    children,
    className,
    isLoading,
    noSendButton = false,
    isSkipable = false,
    errorMessage,
    isIframe,
    botAvatar,
    isLastMessage,
    isTextArea,
    isTextOnly,
  } = props;
  return (
    <div
      className={classNames(
        "flex gap-2 self-stretch",
        isIframe ? "items-end p-4" : "",
      )}
    >
      <MessageAvatar
        isSent={false}
        isIframe={isIframe}
        botAvatar={botAvatar}
        isLastMessage={isLastMessage}
      />
      {isTextOnly ? (
        <TextOnlyMessage>{children}</TextOnlyMessage>
      ) : (
        <div
          className={classNames(
            "flex flex-1 flex-col items-end gap-1.5 rounded-xl border border-solid border-supporting-divider p-4",
            "focus-within:shadow-[0px_8px_16px_0px_rgba(17,24,39,0.10)]",
            className,
          )}
        >
          <div className="flex justify-between gap-2 self-stretch pl-[3px]">
            {label && (
              <label className="flex-1 text-sm font-medium not-italic leading-5 text-dark">
                {label}
              </label>
            )}
            {isSkipable && type !== "disabled" && (
              <div className="bg-[var(--whiteOrChatBotColor)] text-sm font-medium">
                Skip
              </div>
            )}
          </div>
          <div
            className={classNames(
              "flex flex-1 items-center justify-between gap-2 self-stretch rounded-lg border border-solid border-supporting-divider px-2",
              type === "disabled" ? "!bg-[#F9FAFB]" : "",
              type === "done" ? "!bg-[#F9FAFB]" : "",
              "focus-within:border-[var(--whiteOrChatBotColor)]",
              errorMessage ? "!border-error" : "",
              isTextArea ? "!items-end py-2" : "",
            )}
          >
            <div className="flex flex-1">{children}</div>
            {!noSendButton && <SendButton type={type} isLoading={isLoading} />}
          </div>
          {!!errorMessage && (
            <p className="self-stretch pl-[3px] text-sm font-medium not-italic leading-5 text-error">
              {errorMessage}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
